export enum AutoCompleteEventType {
    removeFromExclusions,
    reset,
}

export interface AutoCompleteEvent {
    type: AutoCompleteEventType;
    element?: any;
}
